/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Sendtime_Label3Inputs */

const en_coinvestments_draftemail_sendtime_label3 = /** @type {(inputs: Coinvestments_Draftemail_Sendtime_Label3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send time`)
};

/**
* | output |
* | --- |
* | "Send time" |
*
* @param {Coinvestments_Draftemail_Sendtime_Label3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_sendtime_label3 = /** @type {((inputs?: Coinvestments_Draftemail_Sendtime_Label3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Sendtime_Label3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_sendtime_label3(inputs)
});
export { coinvestments_draftemail_sendtime_label3 as "coInvestments_draftEmail_sendTime_label" }